module.exports = __webpack_public_path__ + "static/media/swapnilKangalarkar.4cda24f2.jpg";